<template lang="pug">
  app-dialog(v-model="$_show" header="Новая папка" confirm-text="Создать" :confirm-disabled="!isReady" @confirm="done")
    app-text-field.mt-6(v-model="name" label="Имя папки" counter="90" :error-text="error" clearable @keyup.enter="done")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { AppDialogToggable } from "@/components"

export default {
  mixins: [AppDialogToggable],
  computed: {
    ...mapState('fileStore', ['folders']),

    preparedName () { return this.name ? this.name.trim() : "" },

    isNameTooLarge () { return this.preparedName.length > 90 },
    isNameUnique () { return this.folders.map(x => x.name.trim()).includes(this.preparedName) == false },

    isReady () { return !this.isNameTooLarge && this.isNameUnique },
    error () {
      if (this.isNameTooLarge) {
        return "Слишком длинное название"
      }
      else if (!this.isNameUnique) {
        return "Папка с таким именем уже существует"
      }
      return null
    }
  },

  methods: {
    ...mapActions('fileStore', ['createFolderWithName']),

    $_beforeShow () {
      this.name = null
    },

    done () {
      if (this.isReady) {
        this.hide()
        this.createFolderWithName(this.preparedName)
      }
    },
  },

  data () {
    return {
      name: null
    }
  }
}
</script>